import ScopedStylesForEdgeBrowserMixin from './edge-browser-support/scoped-styles-for-edge-browser-mixin.js';

const isMicrosoftEdge = typeof HTMLSlotElement === 'undefined';

function defineCustomElement(tagName, constructor, fallbackConstructorForMicrosoftEdge) {

  if (customElements.get(tagName)) {
    const error = new Error(`Custom element for ${tagName} is already defined`);
    setTimeout(() => { throw error; }, 10);
    return;
  }

  if (isMicrosoftEdge && fallbackConstructorForMicrosoftEdge)  {
    customElements.define(tagName, ScopedStylesForEdgeBrowserMixin(fallbackConstructorForMicrosoftEdge));
  } else if (isMicrosoftEdge) {
    customElements.define(tagName, ScopedStylesForEdgeBrowserMixin(constructor));
  } else {
    customElements.define(tagName, constructor);
  }
}

export default defineCustomElement;
